// extracted by mini-css-extract-plugin
export default {"tab":"_Qgmg","tab--active":"q2PEf","tab--disabled":"EFIm5","tooltip":"ZsAsn"};